import page__affiliate from '../pages/affilate'
import page__agency_keyword from '../pages/agency/keyword'
import page__agency_plan from '../pages/agency/plan'
import page__agency_plan_order from '../pages/agency/plan_order'
import page__agency_plan_v2 from '../pages/agency/planv2'
import page__ads_center from '../pages/center/ads_center'
import page__data_center from '../pages/center/data_center'
import page__flash_sale_report from '../pages/center/flash_sale_report.vue'
import page__monthly_report from '../pages/center/monthly_report'
import page__order_center from '../pages/center/order_center'
import layout_dashboard from '../pages/dashboard/Dashboard.vue'
import page__flash_sale from '../pages/flash_sale/index'
import page__shopee_flash_sale_campaign from '../pages/flash_sale_shopee/index.vue'
import page_forgot_password from '../pages/forgot/confirm'
import page_verify_password from '../pages/forgot/verify'
import page__form_ai from '../pages/form/ai_form.vue'
import page__info from '../pages/info/index'
import page__keyword from '../pages/keyword/index'
import updated_product_pack from '../pages/package/list'
// import product_pack from '../pages/package/index'
import new_product_pack from '../pages/package/new'
import page__marketing_pas_index from '../pages/pas'
import page__marketing_log_auto_by_ai from '../pages/pas/log/auto_by_ai.vue'
import page__marketing_log_auto_by_ai_performance from '../pages/pas/log/auto_by_ai_performance.vue'
import page__marketing_log_auto_condition_action from '../pages/pas/log/auto_condition_action.vue'
import page__shop_product from '../pages/product/index'
import page__shop from '../pages/shop/index'
import page__handle_sign from '../pages/sign/handle'
import page__ipayment from '../pages/sign/ipayment'
import page_login from '../pages/sign/login.vue'
import page__register from '../pages/sign/register'
import page__sub_account from '../pages/sub_account/index'
import page__test from '../pages/test'
import page__survey_analysis from '../pages/tool/analysis.vue'
import page__crawl_keyword from '../pages/tool/crawl.vue'
import page__spoil_position_ads from '../pages/tool/spoil.vue'

import page__agency_survey from '../pages/tool/survey.vue'
import page__voucher from '../pages/voucher/index'
import page__agency_check_position from '../temp/agency/check_position.vue'

// import page__redirect_check_position from '../temp/marketing/check_position/redirect'
// import page__check_position_ads from '../temp/marketing/check_position/ads'
// import page__marketing_online from '../temp/marketing/index'
// import page__marketing_list from '../temp/marketing/list'
// import page__anti_click_report from '../temp/marketing/click_report'
// import page__targeting_marketing from '../temp/marketing/targeting/index'
// import page__targeting_position from '../temp/marketing/targeting/position'
// import page__targeting_position_ads from '../temp/marketing/targeting/position_ads'
// import page__boost_ads from '../temp/marketing/boost_ads'
// import page_login_v2 from '../temp/sign/loginv2.vue'
// import page_forgot_password_v2 from '../temp/sign/confirm_v2.vue'
// import page_verify_password_v2 from '../temp/sign/verify_v2.vue'
// import page__register_v2 from '../temp/sign/registerv2.vue'
// import page__payment from '../temp/sign/payment.vue'
// import page__survey from '../temp/survey'
// import page__survey_douyin from '../temp/survey/douyin'
// import page__keyword_v2 from '../temp/keyword/index_v2.vue'
// import page__keyword_private from '../temp/keyword/private.vue'
// import page__ads_analysis from '../temp/center/ads_analysis.vue'
// import page__spike_day_suggestion from '../temp/center/spike_day_suggestion.vue'
// import page__spike_day_suggestion_detail from '../temp/center/spike_day_suggestion_detail.vue'


const routes = [
  {
    path: '/',
    component: layout_dashboard,
    children: [
      {
        path: '',
        component: updated_product_pack
      },
      {
        path: 'info',
        component: page__info
      },
      {
        path: 'product-pack',
        component: updated_product_pack
      },
      {
        path: 'product-pack-new',
        component: new_product_pack
      },
      {
        path: 'packages',
        component: updated_product_pack
      },
      {
        path: 'spoil-ads',
        component: page__spoil_position_ads
      },
      {
        path: 'analysis',
        component: page__survey_analysis
      },
      {
        path: 'marketing/pas',
        component: page__marketing_pas_index,
      },
      {
        path: 'marketing/campaigns',
        component: page__marketing_pas_index,
      },
      {
        path: 'marketing/group',
        component: page__marketing_pas_index,
      },
      {
        path: 'marketing/log/auto_condition',
        component: page__marketing_log_auto_condition_action,
      },
      {
        path: 'marketing/log/atosa_ai',
        component: page__marketing_log_auto_by_ai,
      },
      {
        path: 'marketing/log/atosa_ai_performance',
        component: page__marketing_log_auto_by_ai_performance,
      },
      {
        path: 'shop',
        component: page__shop
      },
      {
        path: 'flash-sale',
        component: page__flash_sale
      },
      {
        path: 'shopee-flash-sale',
        component: page__shopee_flash_sale_campaign
      },
      {
        path: 'shopee-flash-sale-campaign',
        component: page__shopee_flash_sale_campaign
      },
      {
        path: 'voucher',
        component: page__voucher
      },
      {
        path: 'sub-account',
        component: page__sub_account
      },
      {
        path: 'shop-product',
        component: page__shop_product
      },
      {
        path: 'data-center',
        component: page__data_center
      },
      {
        path: 'ads-center',
        component: page__ads_center
      },
      {
        path: 'monthly-report',
        component: page__monthly_report
      },
      {
        path: 'flash-sale-report',
        component: page__flash_sale_report
      },
      {
        path: 'order-center',
        component: page__order_center
      },
      {
        path: 'keyword',
        component: page__keyword
      },
      {
        path: 'shopee-trend',
        component: page__crawl_keyword
      },
      {
        path: 'agency-survey',
        component: page__agency_survey
      },
      {
        path: 'agency-keyword',
        component: page__agency_keyword
      },
      {
        path: 'agency-check-position',
        component: page__agency_check_position
      },
      {
        path: 'agency-plan',
        component: page__agency_plan
      },
      {
        path: 'agency-plan-order',
        component: page__agency_plan_order
      },
      {
        path: 'agency-plan-v2',
        component: page__agency_plan_v2
      },
      {
        path: '/ipayment',
        component: page__ipayment
      },
      {
        path: '/affiliate',
        component: page__affiliate
      },
      {
        path: '/test',
        component: page__test
      }
    ]
  },
  {
    path: '/register',
    component: page__register
  },
  {
    path: '/login',
    name: 'login-page',
    component: page_login
  },
  {
    path: '/forgot-password',
    name: 'forgot-password-page',
    component: page_forgot_password
  },
  {
    path: '/forgot-password/verify',
    name: 'verify-password-page',
    component: page_verify_password
  },
  {
    path: '/handle',
    component: page__handle_sign
  },
  {
    path: '/form/Rl64bF8Ynafd1wszERguCBG8szb',
    component: page__form_ai
  },
  {
    path: '*',
    redirect: '/'
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js